<template>
	<div class="meeting-info max-content">
		<top :title="title" :color="color"></top>
		<div ref="container">
			<div class="info" v-for="(value, index) in infoData" :key="index">
				<h3 v-if="meeting_id!=527" class="title"><span :style="{ borderLeftColor: color }"></span>{{ value.title }}</h3>
				<div class="content" v-html="value.content" @click="previewImages">
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { MeetingInfo, ButtonDetail } from '../../../config/interface.js'
import Top from '../components/Top'
export default {
	components: {
		Top
	},
	data() {
		return {
			infoData: [],
			meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id,
			button_id: this.$route.query.button_id ? this.$route.query.button_id : this.$route.query.b_id,
			title: '',
			color: '#FFFFFF'
		}
	},

	mounted() {
		if (this.meeting_id == 490 && this.button_id == 1898) {
			this.$router.replace({
				path: "/vascularNews/meeting/live",
				query: { meeting_id: this.meeting_id, button_id: this.button_id }
			});
			return;
		}
		this.getInfoData();
		this.getButtonData();
	},
	methods: {
		//获取大会信息
		getInfoData() {
			const url = MeetingInfo;
			let params = {
				meeting_id: this.meeting_id,
				button_id: this.button_id
			}
			const method = "POST";
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						this.infoData = res.data;
					}
				})
		},
		//获取按钮信息
		getButtonData() {
			if (this.button_id) {
				const url = ButtonDetail;
				let params = {
					button_id: this.button_id
				}
				const method = "POST";
				fetch(url, params, method)
					.then((res) => {
						if (res.code == 0) {
							document.title = res.data.share_title;
							this.title = res.data.name;
							if (common.is_weixin()) {
								let data = res.data;
								common.wxShare(data.share_title, data.share_sub_title, data.share_img);
							}
							if (res.data.theme_color_hex) {
								this.color = res.data.theme_color_hex
							} else {
								this.color = '#901D22'
							}
						}
					})

			}
		},
		//图片预览
		previewImages(e) {
			e.stopPropagation();
			console.log(e.target.parentNode['nodeName'])
			if (e.target && e.target['nodeName'] == "IMG" && e.target.parentNode['nodeName']!='A') {
				let previewArr = [];
				let imgs = this.$refs.container.querySelectorAll('img');
				imgs.forEach((img) => {
					previewArr.push(common.fullUrlProtocol(img.getAttribute('src')));
				})
				console.log(previewArr)
				common.wxPreviewImage(common.fullUrlProtocol(e.target.getAttribute('src')), previewArr);
			}
		},
	}
}
</script>
<style lang="scss">
.meeting-info {
	width: 100%;

	.info {
		background: white;
		margin-bottom: 10px;
		font-family: -apple-system, PingFangSC-bold, PingFangSC-bold;
		padding: 15px;

		.title {
			font-size: 15px;
			color: #676767;
			line-height: 40px;
			display: flex;
			align-items: center;

			span {
				display: inline-block;
				vertical-align: 0px;
				height: 15px;
				border-left: 5px solid $color-main;
				margin-right: 5px;
			}
		}

		.content {
			color: #9B9CA0;
			line-height: 30px;
			font-size: 14px;
			width: 100%;

			a{
				display: inline-block;
			}

			img {
				width: 100%;
				max-width: 100% !important;
				height: auto !important;
			}

			.video-js {
				max-width: 100% !important;
				margin: 0 auto;
				width: auto;
				height: auto;

				.vjs-big-play-button {
					top: 0;
					left: 0;
					bottom: 0;
					right: 0;
					margin: auto;
				}
			}
		}

		section {
			max-width: 100% !important;
		}
	}

}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/MeetingInfo.vue